import { useLocation } from 'react-router-dom';
import { useEspecificacao } from '../../contexts/EspecificacaoContext';
import CestaEspecificacao from './CestaEspecificacao';
import AdicionarEspecificacao from './AdicionarEspecificacao';
import ItemLivreModal from './ItemLivreModal';
import './especificacao.css';

/** Camadas globais da especificação: cesta, "+ Especificar", item livre e o aviso. */
export default function EspecificacaoOverlays() {
  const esp = useEspecificacao();
  if (!esp?.habilitado) return null;
  const { cestaAberta, produtoAdd, livre, aviso, fecharAviso } = esp;
  return (
    <>
      <BolhaEspecificacao />
      {cestaAberta && <CestaEspecificacao />}
      {produtoAdd && <AdicionarEspecificacao key={produtoAdd.codpro} />}
      {livre && <ItemLivreModal key={livre.item?.id || 'novo'} />}
      {aviso && (
        <div className="esp-aviso" role="status">
          <i className="bi bi-check-circle-fill" />
          <span>{aviso.texto}</span>
          {aviso.acao && <button type="button" onClick={() => { aviso.acao.fn(); fecharAviso(); }}>{aviso.acao.rotulo}</button>}
          <button type="button" className="x" onClick={fecharAviso} aria-label="Fechar aviso"><i className="bi bi-x" /></button>
        </div>
      )}
    </>
  );
}

/**
 * Bolha da especificação no canto inferior direito, sempre à mão enquanto o
 * arquiteto navega pelos produtos (catálogo e detalhe) — aparece assim que existe
 * uma especificação em andamento. O contador "pula" quando entra item.
 */
function BolhaEspecificacao() {
  const esp = useEspecificacao();
  const { pathname } = useLocation();
  const nosProdutos = pathname === '/catalogo' || pathname.startsWith('/catalogo/');
  if (!nosProdutos || !esp.ativa || esp.cestaAberta) return null;
  const n = esp.totalItens;
  return (
    <button type="button" className="fab" onClick={esp.abrirCesta} aria-label={`Abrir a especificação ${esp.ativa.nome}`}>
      <i className="bi bi-clipboard2-check" />
      {n > 0 && <span key={n} className="fab-n">{n}</span>}
      <span className="fab-rotulo"><strong>{esp.ativa.nome}</strong>{n} {n === 1 ? 'item' : 'itens'}</span>
    </button>
  );
}

/**
 * Botão "Especificação" no topo do catálogo/detalhe — porta de entrada ANTES de
 * começar. Depois que existe uma especificação, quem assume é a bolha do canto.
 */
export function BotaoEspecificacao({ className = '' }) {
  const esp = useEspecificacao();
  if (!esp?.habilitado || esp.ativa) return null;
  const n = esp.totalItens;
  return (
    <button type="button" className={`esp-botao ${n ? 'tem' : ''} ${className}`} onClick={esp.abrirCesta}
      title={esp.ativa ? `Especificação: ${esp.ativa.nome}` : 'Especificação'}>
      <i className="bi bi-clipboard2-check" />
      <span className="esp-botao-txt">{esp.ativa ? esp.ativa.nome : 'Especificação'}</span>
      {n > 0 && <span className="esp-botao-n">{n}</span>}
    </button>
  );
}
